import "./Terrigma.module.css";
import Header from "@/reusable_sections/Header";
import Pricing from "./sections/Pricing";
import JoinTheWaitlist from "./sections/JoinTheWaitlist";
import NojnojsupplyyFooter from "@/reusable_sections/Footer";
import FuturisticHero from "./sections/FuturisticHero";
import PromotionalServices from "./sections/PromotionalServices";
import AboutMe from "./sections/AboutMe";
import MasterTheRhythm from "./sections/MasterTheRhythm";
export default function TerrigmaPage() {
  return <div>
      <Header />
      <FuturisticHero />
      {}
      <Pricing />
      <JoinTheWaitlist />
      <PromotionalServices />
      <AboutMe />
      <MasterTheRhythm />
      <NojnojsupplyyFooter />
    </div>;
}